<app-landing-header></app-landing-header>

<div class="container">
  <div class="container-fluid">
    <div class="social-dash-wrap">
      <div class="row">
        <div class="card">
          <div class="card-body">
            <div class="info-section">
              <h2
                class="text-center"
                [innerHTML]="'privacy_policy.title' | translate"
              >
                <!-- Privacy Policy -->
              </h2>
              <p [innerHTML]="'privacy_policy.intro_first' | translate">
                <!-- Removia ("we," "us," or "our") respects your privacy and is
                committed to protecting your personal data. This Privacy Policy
                explains how we collect, use, disclose, and safeguard your
                information when you visit our website Removia.io and use our
                data removal services (collectively, the "Service"). -->
              </p>
              <p [innerHTML]="'privacy_policy.intro_second' | translate">
                <!-- We collect only the personal information necessary to remove
                your data from data brokers, do not sell your data to third
                parties, and automatically delete your information twelve months
                after your subscription ends. -->
              </p>
            </div>
            <div class="info-section">
              <h5 [innerHTML]="'privacy_policy.section_1.title' | translate">
                <!-- 1. Information We Collect -->
              </h5>
              <h5
                [innerHTML]="'privacy_policy.section_1.subtitle1' | translate"
              >
                <!-- 1.1 Personal Information You Provide -->
              </h5>
              <p [innerHTML]="'privacy_policy.section_1.p1' | translate">
                <!-- When you register for our services, submit data deletion
                requests, or contact us, we collect personal information
                necessary to provide effective data removal services. This
                includes your full name, email address, phone number, and
                country and state or province of residence for account creation
                and service delivery. -->
              </p>
              <p [innerHTML]="'privacy_policy.section_1.p2' | translate">
                <!-- To facilitate comprehensive data removal, we collect information
                about your digital footprint including your current and past
                home addresses up to three addresses per user, additional email
                addresses you want protected under your chosen plan up to five
                per plan, alternative names or aliases you have used, and phone
                numbers associated with your identity that may appear in data
                broker databases. -->
              </p>
              <p [innerHTML]="'privacy_policy.section_1.p3' | translate">
                <!-- For authorization and verification purposes, we collect your
                digital signature on authorization forms granting us legal
                authority to act on your behalf, identity verification documents
                when required by specific data brokers for removal requests, and
                your date of birth only when necessary for broker verification
                processes. -->
              </p>
              <p [innerHTML]="'privacy_policy.section_1.p4' | translate">
                <!-- Payment information is processed through our secure payment
                processor FastSpring®, and while we collect billing information
                necessary for subscription management, we do not store complete
                payment card details on our systems. We also maintain records of
                your communications with our support team and any feedback you
                provide to help us improve our services. -->
              </p>
              <p [innerHTML]="'privacy_policy.section_1.p5' | translate">
                <!-- Under the General Data Protection Regulation, our legal basis
                for processing includes contract performance for data necessary
                to provide the removal services you requested, legitimate
                interests for service improvement, fraud prevention, and
                customer support activities, consent for marketing
                communications where required by law, and legal compliance
                obligations including data protection and financial regulations. -->
              </p>
              <h5
                [innerHTML]="'privacy_policy.section_1.subtitle2' | translate"
              >
                <!-- 1.2 Automatically Collected Information -->
              </h5>
              <p [innerHTML]="'privacy_policy.section_1.p6' | translate">
                <!-- When you use our website and services, we collect minimal
                technical information necessary for service delivery and
                security. This includes general location information at the
                country or regional level, basic device type and browser
                information for compatibility purposes, pages you visit on our
                site and time spent for service improvement, and referring
                websites and search terms to understand how users find our
                service. -->
              </p>
              <p [innerHTML]="'privacy_policy.section_1.p7' | translate">
                <!-- For service delivery, we track your dashboard login activity and
                frequency for security purposes, monitor which features you use
                within your account to improve user experience, and maintain
                progress tracking and removal request status information to
                provide accurate reporting through your dashboard. -->
              </p>
              <p [innerHTML]="'privacy_policy.section_1.p8' | translate">
                <!-- For security purposes, we collect IP addresses for fraud
                prevention and account protection, maintain login attempt logs
                and security event records, and store session information
                necessary for secure account access. We specifically do not
                collect detailed browsing history or engage in behavior tracking
                beyond our site, do not access personal content from your emails
                or social media accounts, do not collect precise location data
                beyond general regional information, and do not process
                biometric or other sensitive personal data categories. -->
              </p>
              <h5
                [innerHTML]="'privacy_policy.section_1.subtitle3' | translate"
              >
                <!-- 1.3 Information from Third Parties -->
              </h5>
              <p [innerHTML]="'privacy_policy.section_1.p9' | translate">
                <!-- We may receive information from data brokers during the
                verification process to confirm your information found on their
                sites and to track the status of removal requests. Our payment
                processor FastSpring® provides us with transaction confirmation
                and payment status information necessary for subscription
                management. When you are referred by one of our business
                partners, we may receive referral information, though this is
                limited to aggregated usage statistics that do not include
                personal identification details. -->
              </p>
            </div>
            <div class="info-section">
              <h5 [innerHTML]="'privacy_policy.section_2.title' | translate">
                <!-- 2. How We Use Your Information -->
              </h5>
              <p [innerHTML]="'privacy_policy.section_2.p1' | translate">
                <!-- We use your personal data exclusively to provide and improve our
                data removal services. Our primary purpose is to submit removal
                requests to data brokers on your behalf using your signed
                authorization, verify your identity as required by various data
                broker procedures, track and report progress on your removal
                requests through your secure dashboard, manage your subscription
                and account access, and process payments through our secure
                payment processor. -->
              </p>
              <p [innerHTML]="'privacy_policy.section_2.p2' | translate">
                <!-- For communication purposes, we send service notifications about
                removal progress and account status, respond to your customer
                support inquiries, provide important updates about service
                changes or legal requirements, and issue security alerts
                regarding account access or suspicious activity. -->
              </p>
              <p [innerHTML]="'privacy_policy.section_2.p3' | translate">
                <!-- To improve our services, we analyze service effectiveness to
                enhance removal success rates, identify new data brokers to add
                to our coverage, enhance user experience on our dashboard and
                website, and develop new features based on user feedback and
                industry developments. -->
              </p>
              <p [innerHTML]="'privacy_policy.section_2.p4' | translate">
                <!-- We process your information to comply with legal obligations
                including data protection laws, prevent fraud and protect
                against unauthorized access, enforce our Terms of Service and
                protect our legal rights, and respond to valid legal requests
                from authorities when required by law. With your explicit
                consent, we may send promotional emails about our services
                though you can opt-out at any time, and we may share success
                stories and testimonials with your explicit permission only. -->
              </p>
            </div>
            <div class="info-section">
              <h5 [innerHTML]="'privacy_policy.section_3.title' | translate">
                <!-- 3. Data Retention -->
              </h5>
              <p [innerHTML]="'privacy_policy.section_3.p1' | translate">
                <!-- We retain your personal data only as long as necessary to
                fulfill our service obligations and comply with applicable legal
                requirements. During your active subscription, we retain service
                data throughout your subscription period for ongoing monitoring,
                maintain removal request records for continuous re-checking and
                progress tracking, and keep your account information current for
                effective service delivery. -->
              </p>
              <p [innerHTML]="'privacy_policy.section_3.p2' | translate">
                <!-- Following the termination of your subscription, we have
                implemented an automatic deletion policy whereby your personal
                data is automatically deleted twelve months after subscription
                termination. This system-wide purge includes all personal
                identifiers and service records, and we employ secure deletion
                protocols to ensure data cannot be recovered after deletion. -->
              </p>
              <p [innerHTML]="'privacy_policy.section_3.p3' | translate">
                <!-- If you prefer not to wait for automatic deletion, you may
                request immediate deletion at any time by emailing
                <a href="mailto:privacy@gotyourbacksupport.com"
                  >privacy@gotyourbacksupport.com</a
                >. We will complete the deletion process within thirty days of
                receiving and verifying your request, and we will provide
                confirmation once the deletion is completed. -->
              </p>
              <p [innerHTML]="'privacy_policy.section_3.p4' | translate">
                <!-- Certain categories of data may be retained longer when required
                by applicable law. Financial records may be retained for up to
                seven years for tax and audit purposes, data related to legal
                disputes will be maintained until final resolution of any
                pending matters, and fraud prevention logs may be kept for up to
                twenty-four months though these are anonymized after twelve
                months. -->
              </p>
              <p [innerHTML]="'privacy_policy.section_3.p5' | translate">
                <!-- We employ data minimization principles, retaining only essential
                data for legal compliance, removing personal identifiers when
                possible while maintaining necessary records, and conducting
                regular reviews to delete data no longer needed. You have the
                right to request information about what specific data we hold
                about you and our retention schedule, immediate deletion is
                available upon request at any time, and we require a
                verification process to protect against unauthorized deletion
                requests. -->
              </p>
              <p [innerHTML]="'privacy_policy.section_3.p6' | translate">
                <!-- Our 12-month retention period after subscription termination
                complies with Article 19 of Japan’s APPI, as this period is
                necessary to: -->
              </p>
              <ul [innerHTML]="'privacy_policy.section_3.list1' | translate">
                <!-- <li>Process any pending removal requests</li>
                <li>Maintain records for legitimate business purposes</li>
                <li>Comply with legal retention requirements</li> -->
              </ul>
              <p [innerHTML]="'privacy_policy.section_3.p7' | translate">
                <!-- After this period, the data is no longer necessary for the
                utilization purpose and is securely deleted. -->
              </p>
            </div>
            <div class="info-section">
              <h5 [innerHTML]="'privacy_policy.section_4.title' | translate">
                <!-- 4. Sharing Your Data -->
              </h5>
              <p [innerHTML]="'privacy_policy.section_4.p1' | translate">
                <!-- We do not sell your personal information to third parties. We
                share your data only as necessary to provide our services and
                comply with legal obligations. -->
              </p>
              <p [innerHTML]="'privacy_policy.section_4.p2' | translate">
                <!-- When working with data brokers, we share only the information
                necessary to submit removal requests on your behalf, limiting
                this strictly to data required for verification and removal
                processes under your signed authorization and our data
                protection agreements. Our essential service providers include
                FastSpring® for secure payment handling, secure cloud
                infrastructure providers for hosting services, encrypted
                communication platforms for customer support, and fraud
                prevention and cybersecurity service providers. All service
                providers must maintain equivalent data protection standards,
                use data only for specified and agreed purposes, implement
                appropriate security measures, comply with applicable data
                protection laws, and return or delete data when their services
                are terminated. -->
              </p>
              <p [innerHTML]="'privacy_policy.section_4.p3' | translate">
                <!-- We may share information when required by law, including
                responding to valid legal process such as subpoenas or court
                orders, complying with regulatory investigations, protecting our
                rights and property, and preventing fraud or illegal activity.
                We maintain a commitment to transparency by challenging overly
                broad or inappropriate requests, notifying users when legally
                permitted, and maintaining logs of all data sharing for
                accountability. -->
              </p>
              <p [innerHTML]="'privacy_policy.section_4.p4' | translate">
                <!-- In the event of a business transfer such as a merger,
                acquisition, or sale of assets, we ensure that user data
                protection is maintained under equivalent privacy standards,
                users are notified of any material changes to data handling, and
                we provide an option to delete data if privacy standards cannot
                be maintained under new ownership. -->
              </p>
            </div>
            <div class="info-section">
              <h5 [innerHTML]="'privacy_policy.section_5.title' | translate">
                <!-- 5. Your Rights and How to Exercise Them -->
              </h5>
              <h5
                [innerHTML]="'privacy_policy.section_5.subtitle1' | translate"
              >
                <!-- 5.1 Universal Rights for All Users -->
              </h5>
              <p [innerHTML]="'privacy_policy.section_5.p1' | translate">
                <!-- All users have fundamental rights regarding their personal
                information. You have the right to access and request a copy of
                all personal data we hold about you, including information about
                how it's processed and shared. You can rectify and update any
                inaccurate or incomplete personal information through your
                account dashboard or by contacting us directly. -->
              </p>
              <p [innerHTML]="'privacy_policy.section_5.p2' | translate">
                <!-- You have the right to erasure, meaning you can request deletion
                of your personal data at any time, subject only to legal
                retention requirements. You can receive your data in a portable
                electronic format suitable for transfer to another service, and
                you can opt-out of marketing communications at any time while
                maintaining full service functionality. -->
              </p>
              <p [innerHTML]="'privacy_policy.section_5.p3' | translate">
                <!-- You can exercise these rights through your account dashboard
                settings for most requests, by emailing
                <a href="mailto:privacy@gotyourbacksupport.com"
                  >privacy@gotyourbacksupport.com</a
                >
                for detailed requests, with our commitment to respond within
                thirty days of receiving a verified request, and with identity
                verification required for security purposes. -->
              </p>
              <h5
                [innerHTML]="'privacy_policy.section_5.subtitle2' | translate"
              >
                <!-- 5.2 GDPR Rights for EU/EEA/UK Residents -->
              </h5>
              <p [innerHTML]="'privacy_policy.section_5.p4' | translate">
                <!-- European residents benefit from enhanced rights under the
                General Data Protection Regulation. You have the right to be
                informed through clear information about how your personal data
                is collected, used, stored, and shared, as provided in this
                Privacy Policy. -->
              </p>
              <p [innerHTML]="'privacy_policy.section_5.p5' | translate">
                <!-- You can object to processing based on legitimate interests,
                including direct marketing, profiling, and research activities.
                You have the right to restrict processing in certain
                circumstances, such as while disputing data accuracy or the
                lawfulness of processing. Where processing is based on consent,
                you can withdraw that consent at any time without affecting
                prior lawful processing. -->
              </p>
              <p [innerHTML]="'privacy_policy.section_5.p6' | translate">
                <!-- You have the right to lodge complaints with your local data
                protection supervisory authority regarding our processing of
                your personal data, and you have protection regarding automated
                decision-making and profiling, including the right to human
                review of automated decisions that significantly affect you. -->
              </p>
              <p [innerHTML]="'privacy_policy.section_5.p7' | translate">
                <!-- To exercise GDPR rights, submit detailed requests via
                <a href="mailto:privacy@gotyourbacksupport.com"
                  >privacy@gotyourbacksupport.com</a
                >
                or contact
                <a href="mailto:privacy@gotyourbacksupport.com"
                  >privacy@gotyourbacksupport.com</a
                >
                for GDPR-specific inquiries. Identity verification is required
                for security purposes, and we respond within thirty days though
                this may extend to sixty days for complex requests. You have the
                right to appeal our decisions to your local data protection
                authority if you are not satisfied with our response. -->
              </p>
              <h5
                [innerHTML]="'privacy_policy.section_5.subtitle3' | translate"
              >
                <!-- 5.3 CCPA Rights for California Residents -->
              </h5>
              <p [innerHTML]="'privacy_policy.section_5.p8' | translate">
                <!-- California residents have specific rights under the California
                Consumer Privacy Act. You have the right to know what personal
                information is collected and how it is used, including the
                categories and specific pieces of personal information we have
                collected about you in the past twelve months, the categories of
                sources from which information was collected, the business or
                commercial purposes for collecting personal information, and the
                categories of third parties with whom we share personal
                information. -->
              </p>
              <p [innerHTML]="'privacy_policy.section_5.p9' | translate">
                <!-- You can access your personal information up to twice per
                twelve-month period and request deletion of personal information
                we have collected from you, subject to certain legal exceptions.
                You have the right to opt-out of the sale of your personal
                information, though we do not sell personal information. You
                cannot be discriminated against for exercising your CCPA privacy
                rights, including through denial of services, different pricing,
                or reduced service quality. -->
              </p>
              <p [innerHTML]="'privacy_policy.section_5.p10' | translate">
                <!-- Under CCPA, we collect identifiers such as name, email, and
                address, contact information, commercial information including
                subscription details, and internet activity such as dashboard
                usage. We collect this information directly from you, from data
                brokers for verification purposes, and from public records. We
                use this information for service delivery, customer support, and
                fraud prevention, and we share it only with service providers,
                not for commercial sale. -->
              </p>
              <p [innerHTML]="'privacy_policy.section_5.p11' | translate">
                <!-- To exercise CCPA rights, use our Data Privacy Request Form at
                gotyourbacksupport.com/request-form or email
                <a href="mailto:privacy@gotyourbacksupport.com"
                  >privacy@gotyourbacksupport.com</a
                >
                with "CCPA Request" in the subject line. A verification process
                is required including identity confirmation, and we respond
                within forty-five days though this may extend to ninety days
                with notification. -->
              </p>
              <h5
                [innerHTML]="'privacy_policy.section_5.subtitle4' | translate"
              >
                <!-- 5.4 Other Jurisdictions and No Retaliation Policy -->
              </h5>
              <p [innerHTML]="'privacy_policy.section_5.p12' | translate">
                <!-- Canadian residents have rights under PIPEDA including access,
                correction, and complaint rights to the Privacy Commissioner of
                Canada. Australian residents can access and correct personal
                information and lodge complaints with the Office of the
                Australian Information Commissioner. Swiss residents have
                GDPR-equivalent rights under the Federal Data Protection Act
                including access, rectification, erasure, and complaints to the
                Federal Data Protection and Information Commissioner. -->
              </p>
              <p [innerHTML]="'privacy_policy.section_5.p13' | translate">
                <!-- Japanese residents have rights under the Act on the Protection
                of Personal Information (APPI). These include the right to
                request disclosure of personal information, correction of
                inaccurate information, suspension of use, or deletion where
                permitted by law. Requests can be submitted to
                <a href="mailto:privacy@gotyourbacksupport.com"
                  >privacy@gotyourbacksupport.com</a
                >, and we will respond in accordance with APPI requirements. -->
              </p>
              <p [innerHTML]="'privacy_policy.section_5.p14' | translate">
                <!-- Fees for Data Access Requests. In accordance with Article 33 of
                APPI, we do not charge fees for: -->
              </p>
              <ul [innerHTML]="'privacy_policy.section_5.list1' | translate">
                <!-- <li>Initial disclosure requests</li>
                <li>Correction requests - Deletion requests</li> -->
              </ul>
              <p [innerHTML]="'privacy_policy.section_5.p15' | translate">
                <!-- If you make repeated or excessive requests, we may charge a
                reasonable fee reflecting our actual administrative costs, which
                will be communicated to you in advance. -->
              </p>
              <p [innerHTML]="'privacy_policy.section_5.p16' | translate">
                <!-- We maintain a strict no-retaliation policy, ensuring that we
                never discriminate against you for exercising privacy rights.
                You will receive the same service quality and access, the same
                pricing and subscription terms, no penalties or restrictions,
                and no different treatment or reduced functionality regardless
                of privacy rights exercise. -->
              </p>
            </div>
            <div class="info-section">
              <h5 [innerHTML]="'privacy_policy.section_6.title' | translate">
                <!-- 6. Cookies and Tracking Technologies -->
              </h5>
              <p [innerHTML]="'privacy_policy.section_6.p1' | translate">
                <!-- We do not use cookies or similar tracking technologies on our
                website. This means we do not store any cookies on your device
                when you visit our website, nor do we use web beacons, pixels,
                or other tracking tools to collect information about your
                browsing activity. -->
              </p>
              <p [innerHTML]="'privacy_policy.section_6.p2' | translate">
                <!-- We specifically do not use session cookies, persistent cookies,
                advertising cookies or trackers, social media tracking pixels,
                cross-site behavioral tracking, third-party advertising
                networks, analytics cookies, or retargeting and remarketing
                tools. -->
              </p>
              <p [innerHTML]="'privacy_policy.section_6.p3' | translate">
                <!-- Our website functions without requiring cookies, and you can
                browse our site and access information without any tracking
                technologies being deployed. User account functionality and
                dashboard access are managed through secure server-side sessions
                that do not require client-side cookies. -->
              </p>
              <p [innerHTML]="'privacy_policy.section_6.p4' | translate">
                <!-- If our policy regarding cookies changes in the future, we will
                update this Privacy Policy accordingly and notify you as
                required by law with advance notice and clear explanation of any
                new tracking technologies we might implement. -->
              </p>
            </div>
            <div class="info-section">
              <h5 [innerHTML]="'privacy_policy.section_7.title' | translate">
                <!-- 7. Children's Privacy -->
              </h5>
              <p [innerHTML]="'privacy_policy.section_7.p1' | translate">
                <!-- Our service is intended exclusively for individuals eighteen
                years or older. We do not knowingly collect data from children
                under eighteen, require age verification during account
                creation, and do not permit parents or guardians to create
                accounts for minors. -->
              </p>
              <p [innerHTML]="'privacy_policy.section_7.p2' | translate">
                <!-- If we discover that we have collected information from someone
                under eighteen, we will immediately delete all associated data,
                terminate the account without penalty, notify the contact email
                address provided, and issue a refund of any payments made. -->
              </p>
              <p [innerHTML]="'privacy_policy.section_7.p3' | translate">
                <!-- If you believe we have collected data from someone under
                eighteen, please contact us immediately at
                <a href="mailto:privacy@gotyourbacksupport.com"
                  >privacy@gotyourbacksupport.com</a
                >
                with details about the suspected underage account. We will
                complete our investigation within twenty-four hours and take
                appropriate action to protect the minor's privacy. -->
              </p>
            </div>
            <div class="info-section">
              <h5 [innerHTML]="'privacy_policy.section_8.title' | translate">
                <!-- 8. Security Measures -->
              </h5>
              <p [innerHTML]="'privacy_policy.section_8.p1' | translate">
                <!-- We implement comprehensive technical and organizational measures
                to protect your data. Technical safeguards include encryption in
                transit using TLS encryption for all data transfers, encryption
                at rest for database and file storage, multi-factor
                authentication requirements for staff access to personal data,
                and network security measures including firewalls, intrusion
                detection, and continuous monitoring. -->
              </p>
              <p [innerHTML]="'privacy_policy.section_8.p2' | translate">
                <!-- Our infrastructure security includes enterprise-grade cloud
                infrastructure, encrypted and geographically distributed
                backups, regular security updates and vulnerability testing, and
                twenty-four hour monitoring with rapid response protocols. -->
              </p>
              <p [innerHTML]="'privacy_policy.section_8.p3' | translate">
                <!-- From an organizational perspective, we maintain staff training
                programs on privacy and data protection requirements, limit
                staff access to data necessary for their specific job functions,
                conduct background checks for personnel handling personal data,
                and require confidentiality agreements with legal obligations
                for all staff members. -->
              </p>
              <p [innerHTML]="'privacy_policy.section_8.p4' | translate">
                <!-- Our operational security includes data minimization practices,
                regular internal and external security assessments, security
                requirements for all service providers, and clear incident
                procedures for security breaches. -->
              </p>
              <p [innerHTML]="'privacy_policy.section_8.p5' | translate">
                <!-- While we implement comprehensive security measures, no method of
                transmission or storage is completely secure. We cannot
                guarantee absolute security but commit to industry best
                practices, continuous improvement of security measures,
                transparent communication about any security incidents, and
                mitigation support if your data is compromised. -->
              </p>
              <h5
                [innerHTML]="'privacy_policy.section_8.subtitle1' | translate"
              >
                <!-- 8.1. Data Breach Notification for Japanese Residents -->
              </h5>
              <p [innerHTML]="'privacy_policy.section_8.p6' | translate">
                <!-- In accordance with Article 22-2 of APPI, if we experience a data
                breach that may significantly harm your rights and interests, we
                will: -->
              </p>
              <ul [innerHTML]="'privacy_policy.section_8.list1' | translate">
                <!-- <li>
                  Report to Japan’s Personal Information Protection Commission
                  (PPC) without delay
                </li>
                <li>
                  Notify affected Japanese residents directly unless it is
                  difficult to do so
                </li>
                <li>
                  Take necessary alternative measures to protect your rights and
                  interests
                </li> -->
              </ul>
              <p [innerHTML]="'privacy_policy.section_8.p7' | translate">
                <!-- Breaches affecting 1,000 or more Japanese individuals will be
                reported to the PPC within the timeframes required by PPC
                regulations. -->
              </p>
            </div>
            <div class="info-section">
              <h5 [innerHTML]="'privacy_policy.section_9.title' | translate">
                <!-- 9. International Data Transfers -->
              </h5>
              <p [innerHTML]="'privacy_policy.section_9.p1' | translate">
                <!-- Our data removal services require international transfers
                because data brokers operate globally across the US, EU, Canada,
                UAE, and other jurisdictions, we utilize secure distributed
                hosting for reliability, and our service providers handle
                payment processing and support tools across multiple countries. -->
              </p>
              <p [innerHTML]="'privacy_policy.section_9.p2' | translate">
                <!-- For transfers involving European Union residents, we comply with
                GDPR requirements through adequacy decisions for transfers to
                countries deemed adequate by the EU Commission, Standard
                Contractual Clauses for other transfers using EU-approved
                agreements, and additional technical and organizational
                safeguards for extra protection. -->
              </p>
              <p [innerHTML]="'privacy_policy.section_9.p3' | translate">
                <!-- For residents of other jurisdictions, we maintain appropriate
                safeguards for California resident data under CCPA, comparable
                protection standards for Canadian PIPEDA compliance, and
                GDPR-equivalent safeguards for Swiss data protection
                requirements. -->
              </p>
              <p [innerHTML]="'privacy_policy.section_9.p4' | translate">
                <!-- Our primary processing occurs in the European Union for EU
                residents' data processing, the United States for service
                delivery and data broker communication, and Canada for backup
                and disaster recovery systems. We limit transfers to the minimum
                necessary data for specific purposes, maintain transfers only
                during active processing needs, ensure equivalent protection
                standards globally, and provide information about transfer
                locations upon request. -->
              </p>
              <h5
                [innerHTML]="'privacy_policy.section_9.subtitle1' | translate"
              >
                <!-- 9.1. Transfers from Japan -->
              </h5>
              <p [innerHTML]="'privacy_policy.section_9.p5' | translate">
                <!-- For Japanese residents, we comply with Article 24 of the Act on
                the Protection of Personal Information (APPI). When we transfer
                your personal data outside Japan, we: -->
              </p>
              <ul [innerHTML]="'privacy_policy.section_9.list1' | translate">
                <!-- <li>
                  Obtain your explicit consent as required by Article 24(1) APPI
                </li>
                <li>
                  Provide you with information about the data protection system
                  in the destination country as required by Article 24(2)
                </li>
                <li>
                  For transfers to data brokers in the United States: We execute
                  contracts requiring equivalent protection measures and conduct
                  continuous monitoring as required by Article 24(3)
                </li>
                <li>
                  For transfers to EU/EEA countries: These are recognized as
                  having adequate protection under PPC regulations
                </li> -->
              </ul>
              <p [innerHTML]="'privacy_policy.section_9.p6' | translate">
                <!-- You can withdraw your consent for international transfers at any
                time by contacting
                <a href="mailto:privacy@gotyourbacksupport.com"
                  >privacy@gotyourbacksupport.com</a
                > -->
              </p>
            </div>
            <div class="info-section">
              <h5 [innerHTML]="'privacy_policy.section_10.title' | translate">
                <!-- 10. Changes to This Privacy Policy -->
              </h5>
              <p [innerHTML]="'privacy_policy.section_10.p1' | translate">
                <!-- We may update this Privacy Policy to reflect changes in
                applicable privacy laws, new service features or modified
                business practices, security improvements and enhanced
                protection measures, and clarifications based on user feedback
                and questions. -->
              </p>
              <p [innerHTML]="'privacy_policy.section_10.p2' | translate">
                <!-- When we make changes, we notify you through email notification
                sent to your registered email address, dashboard alerts with
                prominent notices in your account, website posting of the
                updated policy with the change date, and a summary of changes
                with clear explanation of material modifications. -->
              </p>
              <p [innerHTML]="'privacy_policy.section_10.p3' | translate">
                <!-- We provide advance notice of at least thirty days for material
                changes affecting your rights, immediate notice for changes that
                enhance your privacy protection, and the choice to close your
                account if you disagree with changes. Continued use of our
                service after changes are posted constitutes acceptance of the
                updated terms. -->
              </p>
              <p [innerHTML]="'privacy_policy.section_10.p4' | translate">
                <!-- We maintain policy history with previous versions available upon
                request for comparison, change tracking with documentation of
                all material modifications, legal compliance records with all
                versions maintained for regulatory requirements, and transparent
                updates with clear indication of what changed and why. -->
              </p>
            </div>
            <div class="info-section">
              <h5 [innerHTML]="'privacy_policy.section_11.title' | translate">
                <!-- 11. Contact Information -->
              </h5>
              <p [innerHTML]="'privacy_policy.section_11.p1' | translate">
                <!-- For privacy inquiries, contact
                <a href="mailto:privacy@gotyourbacksupport.com"
                  >privacy@gotyourbacksupport.com</a
                >
                with initial response within twenty-four hours, and include
                "Privacy Inquiry" in the subject line for faster processing. -->
              </p>
              <p [innerHTML]="'privacy_policy.section_11.p2' | translate">
                <!-- GDPR-related inquiries from EU and UK residents should be
                directed to privacy@gotyourbacksupport.com, with response
                provided within thirty days as required by GDPR. -->
              </p>
              <p [innerHTML]="'privacy_policy.section_11.p3' | translate">
                <!-- Our company, GotYourBack Technologies Ltd., is located at
                Ifigeneias 14, 3036 Limassol, Cyprus. For general support,
                contact support@removia.io, for business partnerships and media
                inquiries contact
                <a href="mailto:support@removia.io">support@removia.io</a>. -->
              </p>
              <p [innerHTML]="'privacy_policy.section_11.p4' | translate">
                <!-- If you are not satisfied with our response to your privacy
                concerns, EU and EEA residents may contact their local data
                protection authority, UK residents may contact the Information
                Commissioner's Office, California residents may contact the
                California Attorney General's Office, Canadian residents may
                contact the Office of the Privacy Commissioner of Canada, and
                Swiss residents may contact the Federal Data Protection and
                Information Commissioner. -->
              </p>
            </div>
            <div class="info-section">
              <h5 [innerHTML]="'privacy_policy.section_12.title' | translate">
                <!-- 12. Definitions -->
              </h5>
              <p [innerHTML]="'privacy_policy.section_12.p1' | translate">
                <!-- For purposes of this Privacy Policy, "Data Broker" means
                companies that collect, aggregate, and sell personal information
                to third parties; "Personal Data" or "Personal Information"
                means any information that identifies or can be used to identify
                an individual; "Processing" means any operation performed on
                personal data, including collection, storage, and deletion;
                "Service" means Removia's data removal services, website, and
                related offerings; and "User" or "You" means any individual
                using our services or visiting our website. -->
              </p>
              <p [innerHTML]="'privacy_policy.section_12.p2' | translate">
                <!-- This Privacy Policy is effective as of June 16, 2025, and
                supersedes all previous versions. We are committed to protecting
                your privacy and will continue to enhance our practices as
                privacy laws and technology evolve. -->
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<app-landing-footer></app-landing-footer>
